import { createContext, useEffect, useMemo, useRef, useState } from 'react';

import {
  ADMIN_USER_CACHE_KEY,
  getCachedAdminPreferences,
  normalizeAdminPreferences,
} from '@/services/adminPreferences';

export const AdminNavigationContext = createContext(null);

export const AdminNavigationProvider = ({ children }) => {
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [desktopOverlayOpen, setDesktopOverlayOpen] = useState(false);
  const [railExpanded, setRailExpanded] = useState(false);
  const [navigationPreferences, setNavigationPreferences] = useState(getCachedAdminPreferences);
  const sidebarModeRef = useRef(navigationPreferences.sidebar_mode);

  useEffect(() => {
    const applyPreferences = (preferences) => {
      const next = normalizeAdminPreferences(preferences);
      if (sidebarModeRef.current !== next.sidebar_mode) setRailExpanded(false);
      sidebarModeRef.current = next.sidebar_mode;
      setNavigationPreferences(next);
      if (next.sidebar_mode !== 'overlay') setDesktopOverlayOpen(false);
    };
    const handlePreferencesChanged = (event) => applyPreferences(event.detail);
    const handleStorage = (event) => {
      if (event.key === ADMIN_USER_CACHE_KEY) applyPreferences(getCachedAdminPreferences());
    };
    window.addEventListener('admin-preferences-changed', handlePreferencesChanged);
    window.addEventListener('storage', handleStorage);
    return () => {
      window.removeEventListener('admin-preferences-changed', handlePreferencesChanged);
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  const value = useMemo(() => ({
    mobileDrawerOpen,
    setMobileDrawerOpen,
    desktopOverlayOpen,
    setDesktopOverlayOpen,
    railExpanded,
    setRailExpanded,
    navigationPreferences,
  }), [desktopOverlayOpen, mobileDrawerOpen, navigationPreferences, railExpanded]);

  return (
    <AdminNavigationContext.Provider value={value}>
      {children}
    </AdminNavigationContext.Provider>
  );
};
